import { ChipOption } from '@marageti/z4-lib';
import { TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import {
  ANY_ASSIGNEE,
  teamMemberSearchRequest,
  formatTeamMembersAsOptions,
} from '../../utils/team-members';
import type { Option, AssigneeOption } from '../../utils/team-members';

export type { Option, AssigneeOption };
export { ANY_ASSIGNEE, teamMemberSearchRequest, formatTeamMembersAsOptions };

export type ExtendedOption = Option & {
  field?: string;
};

export const sortByOptionsAll: ExtendedOption[] = [
  { title: 'Request Date', value: 'createdAt' },
  { title: 'Departure Date', value: 'departureDate' },
  { title: 'Budget (PPPD)', value: 'pppd' },
  { title: 'Budget (Total)', value: 'totalBudget' },
];

export const sortByOptionPecv: ExtendedOption = { title: 'Est. Value (TREV)', value: 'initialPecv' };

export const sortByOptionsIncoming: Option[] = [
  { title: 'Budget (Total)', value: 'totalBudget' },
  { title: 'Budget (PPPD)', value: 'pppd' },
  { title: 'Departure Date', value: 'departureDate' },
  { title: 'Request Date (New to Old)', value: 'createdAtDesc' },
  { title: 'Request Date (Old to New)', value: 'createdAtAsc' },
];

export const orderByOptions: ExtendedOption[] = [
  { title: 'New to Old', value: 'desc', field: 'createdAtDesc' },
  { title: 'Old to New', value: 'asc', field: 'createdAtAsc' },
  { title: 'New to Old', value: 'desc', field: 'departureDate' },
  { title: 'Old to New', value: 'asc', field: 'departureDate' },
  { title: 'High to Low', value: 'desc', field: 'pppd' },
  { title: 'Low to High', value: 'asc', field: 'pppd' },
  { title: 'High to Low', value: 'desc', field: 'totalBudget' },
  { title: 'Low to High', value: 'asc', field: 'totalBudget' },
];

export const orderByOptionsPecv: ExtendedOption[] = [
  { title: 'High to Low', value: 'desc', field: 'initialPecv' },
  { title: 'Low to High', value: 'asc', field: 'initialPecv' },
];

export const tagOptions: ChipOption[] = [
  { key: 0, label: 'All', value: 'ALL' },
  { key: 1, label: 'VIP', value: 'vip' },
  { key: 2, label: 'Repeat', value: 'repeatTraveler' },
  { key: 8, label: 'FOBY', value: 'foby' },
  { key: 3, label: 'PRL', value: 'prl' },
  { key: 4, label: 'Bad Apple', value: 'badApple' },
  { key: 5, label: 'Red Flag', value: 'redFlag' },
  { key: 6, label: 'Travel Agent', value: 'travelAgent' },
  { key: 7, label: 'Junk', value: 'junk' },
];

export const statusChips: ChipOption[] = [
  { key: 0, label: 'Unverified', value: TripRequestStatus.PendingStatus },
  { key: 1, label: 'Unmatched', value: TripRequestStatus.VerifiedStatus },
  { key: 2, label: 'Matched', value: TripRequestStatus.MatchedStatus },
  { key: 3, label: 'Sold', value: TripRequestStatus.SoldStatus },
  { key: 4, label: 'Postponed', value: TripRequestStatus.PostponedStatus },
  { key: 5, label: 'Referred', value: TripRequestStatus.ReferredStatus },
  { key: 6, label: 'Canceled', value: TripRequestStatus.CanceledStatus },
  { key: 7, label: 'Junk', value: TripRequestStatus.JunkStatus },
];
